export enum EducationLevel {
  SCHOOL = "School",
  UNDERGRADUATE = "Undergraduate",
  POSTGRADUATE = "Post Graduate",
}

export enum LanguageEnum {
  ENGLISH = "English",
  HINDI = "Hindi",
  TAMIL = "Tamil",
  TELUGU = "Telugu",
  BENGALI = "Bengali",
  MARATHI = "Marathi",
  MALAYALAM = "Malayalam",
  KANNADA = "Kannada",
  URDU = "Urdu",
  PUNJABI = "Punjabi",
}

export enum LocationPreference {
  ALL_LOCATIONS = "All Locations",
  LOCAL = "Local (State)",
  INDIA = "Anywhere in India",
  GLOBAL = "Global",
}

export enum PortfolioSuperCategory {
  ACTOR = "actor",
  MODEL = "model",
  SINGER = "singer",
  DANCER = "dancer",
  ANCHOR = "anchor",
  PHOTOGRAPHER = "photographer",
}

export enum PortfolioCategory {
  MOVIE_ACTOR = "movie_actor",
  TV_ACTOR = "tv_actor",
  THEATER_ACTOR = "theater_actor",
  FASHION_MODEL = "fashion_model",
}

export enum KycStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
  UNDER_REVIEW = "under_review",
}

export enum PortfolioStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending",
  REJECTED = "rejected",
  SUSPENDED = "suspended",
}

export enum AccountStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  PENDING = "pending",
  REJECTED = "rejected",
  SUSPENDED = "suspended",
}

export interface Portfolio {
  _id: string;
  userId: string;
  mainImage: string;
  name: string;
  dob?: string;
  age?: number;
  gender: string;
  aboutMe: string;
  educationLevel?: EducationLevel;
  degree?: string;
  height?: number;
  weight?: number;
  bust?: number;
  waist?: number;
  hips?: number;
  chest?: number;
  biceps?: number;
  hairType?: string;
  hairLength?: number;
  eyeColor?: string;
  professions: string[];
  skills?: string;
  hasMovies?: boolean;
  movieNames?: string[];
  hasWebseries?: boolean;
  webseriesNames?: string[];
  hasTVShows?: boolean;
  tvShowNames?: string[];
  hasShortFilms?: boolean;
  shortFilmNames?: string[];
  hasAds?: boolean;
  adNames?: string[];
  hasModel?: boolean;
  fashionEventNames?: string[];
  locationPreference: LocationPreference[];
  knownLanguages?: LanguageEnum[];
  fluentLanguages?: LanguageEnum[];
  instagram?: string;
  twitter?: string;
  youtube?: string;
  facebook?: string;
  youtubeVideos?: string[];
  instagramReels?: string[];
  photos?: string[];
  contactName?: string;
  email?: string;
  mobile?: string;
  followers: string[];
  following: string[];
  posts: string[];
  stories: string[];
  portfolioStatus: PortfolioStatus;
  accountStatus: AccountStatus;
  portfolioSuperCategory: PortfolioSuperCategory;
  portfolioCategory: PortfolioCategory;
  kycStatus: KycStatus;
  isDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePortfolioRequest {
  mainImage: string;
  name: string;
  dob?: string;
  age?: number;
  gender: string;
  aboutMe: string;
  educationLevel?: EducationLevel;
  degree?: string;
  height?: number;
  weight?: number;
  bust?: number;
  waist?: number;
  hips?: number;
  chest?: number;
  biceps?: number;
  hairType?: string;
  hairLength?: number;
  eyeColor?: string;
  professions: string[];
  skills?: string;
  hasMovies?: boolean;
  movieNames?: string[];
  hasWebseries?: boolean;
  webseriesNames?: string[];
  hasTVShows?: boolean;
  tvShowNames?: string[];
  hasShortFilms?: boolean;
  shortFilmNames?: string[];
  hasAds?: boolean;
  adNames?: string[];
  hasModel?: boolean;
  fashionEventNames?: string[];
  locationPreference: LocationPreference[];
  knownLanguages?: LanguageEnum[];
  fluentLanguages?: LanguageEnum[];
  instagram?: string;
  twitter?: string;
  youtube?: string;
  facebook?: string;
  youtubeVideos?: string[];
  instagramReels?: string[];
  photos?: string[];
  contactName?: string;
  email?: string;
  mobile?: string;
}

export interface UpdatePortfolioRequest extends Partial<CreatePortfolioRequest> {}

export interface PortfolioState {
  portfolio: Portfolio | null;
  myPortfolio: Portfolio | null;
  allPortfolios: Portfolio[];
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
  totalCount: number;
}

export interface PortfolioResponse {
  message: string;
  data: Portfolio;
}

export interface AllPortfoliosResponse {
  message: string;
  data: Portfolio[];
  totalCount: number;
}

export interface BaseResponse {
  message: string;
  success: boolean;
}
